import { motion } from 'framer-motion';
import { Phone, Envelope, MapPin, InstagramLogo, FacebookLogo, LinkedinLogo } from '@phosphor-icons/react';
import { useLanguage } from '@/contexts/LanguageContext';
import LogoDisplay from '@/components/LogoDisplay';
import { CONTACT_PHONE, CONTACT_PHONE_DISPLAY } from '@/config';

const Footer = () => {
  const { t } = useLanguage();

  const navLinks = [
    { key: 'footerNavAccueil', href: '#accueil' },
    { key: 'footerNavServices', href: '#services' },
    { key: 'footerNavReserver', href: '#reserver' },
    { key: 'footerNavApropos', href: '#apropos' },
    { key: 'footerNavContact', href: '#contact' },
  ];

  return (
    <footer id="contact" className="py-24 bg-[#0A0A0A] border-t border-white/5" data-testid="footer">
      <div className="app-shell">
        <div className="mb-16 grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-4 inline-flex rounded-2xl border border-[#D4AF37]/15 bg-[#101010] px-4 py-3">
              <LogoDisplay className="h-[2.625rem] w-[10rem] sm:h-[3.125rem] sm:w-[11.875rem]" priority />
            </div>
            <p className="text-[#A1A1AA] max-w-md leading-relaxed mb-6">
              {t('footerBrandDesc')}
            </p>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#141414] border border-white/10 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all duration-300 group"
                data-testid="social-instagram"
              >
                <InstagramLogo size={20} className="text-[#A1A1AA] group-hover:text-[#0A0A0A]" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#141414] border border-white/10 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all duration-300 group"
                data-testid="social-facebook"
              >
                <FacebookLogo size={20} className="text-[#A1A1AA] group-hover:text-[#0A0A0A]" />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-[#141414] border border-white/10 flex items-center justify-center hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all duration-300 group"
                data-testid="social-linkedin"
              >
                <LinkedinLogo size={20} className="text-[#A1A1AA] group-hover:text-[#0A0A0A]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#D4AF37]">{t('navigation')}</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.key}>
                  <a
                    href={link.href}
                    className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors"
                  >
                    {t(link.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-[#D4AF37]">{t('contact')}</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-[#D4AF37] mt-1" />
                <a href={`tel:${CONTACT_PHONE}`} className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="contact-phone">
                  {CONTACT_PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Envelope size={20} className="text-[#D4AF37] mt-1" />
                <a href="mail:reservation@econnect-vtc.com" className="text-[#A1A1AA] hover:text-[#D4AF37] transition-colors" data-testid="contact-email">
                  reservation@econnect-vtc.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#D4AF37] mt-1" />
                <span className="text-[#A1A1AA]">
                  À Paris et dans toute la France
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col items-start justify-between gap-4 border-t border-white/5 pt-8 text-left md:flex-row md:items-center">
        <p className="text-sm text-[#A1A1AA]">
            {t('copyright')}
          </p>
          <div className="flex flex-wrap gap-4 sm:gap-6">
            <a href="#" className="text-[#A1A1AA] text-sm hover:text-[#D4AF37] transition-colors">
              {t('mentionsLegales')}
            </a>
            <a href="#" className="text-[#A1A1AA] text-sm hover:text-[#D4AF37] transition-colors">
              {t('politiqueConfidentialite')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
